import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Banner = ({ bannerData }) => {
  useEffect(() => {
    if (bannerData.length && window.initSwiper) {
      window.initSwiper();
    }
  }, [bannerData]);

  return (
    <section className="tf-slideshow slider-effect-fade slider-home-5 position-relative">
      <div className="swiper tf-sw-slideshow" data-preview="1" data-tablet="1" data-mobile="1" data-centered="false" data-space="0" data-loop="true" data-auto-play="true" data-delay="2000" data-speed="1000">
        <div className="swiper-wrapper">
          {bannerData.map((banner, index) => (
            <div className="swiper-slide" lazy="true" key={index}>
              <div className="wrap-slider">
                <img className="lazyload" data-src={banner.imageSource} src={banner.imageSource} alt={banner.name} />
                <div className="box-content text-center">
                  <div className="container">
                    {/* <h1 className="fade-item fade-item-1 text-white heading">{banner.name}</h1>
                    <p className="fade-item fade-item-2 text-white">{banner.description}</p> */}

                    <Link to={banner.link} className="fade-item fade-item-3 tf-btn btn-primary animate-hover-btn btn-xl radius-60">
                    <span>Shop now</span>
                    <i className="icon icon-arrow-right"></i>
                    </Link>

                    {/* <a href={banner.link} className="fade-item fade-item-3 tf-btn btn-primary animate-hover-btn btn-xl radius-60">
                      <span>Shop now</span>
                      <i className="icon icon-arrow-right"></i>
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="wrap-pagination">
        <div className="sw-dots style-2 dots-white sw-pagination-slider justify-content-center"></div>
      </div>
    </section>
  );
};

export default Banner;
